import React, {useState, useEffect} from 'react'
// Styles
import './lgdest.style.css';
// Constant
import { Base_API } from '../../_actions/matcher'
import { NhealthAction } from '../../_actions/action.api'
import liff from '@line/liff'
// Alert
import Swal from 'sweetalert2';
// React Router Dom
import { useParams } from 'react-router-dom'
import { DecryptedOBJ, DecryptedText, EncryptedOBJ, EncryptedText } from '../../utils/Encryption';
import lineConfig from '../../_actions/authLine/lineConfig';



function InviteeWelcome() {
    // ~~~~~~~~~~~~~~~~~~~~~~ Params ~~~~~~~~~~~~~~~~~~~~~~ //

    const { inviterID } = useParams();

    // ~~~~~~~~~~~~~~~~~~~~~~ UseState ~~~~~~~~~~~~~~~~~~~~~~ //

    const [loading, setLoading] = useState(true);
    
    // ~~~~~~~~~~~~~~~~~~~~~~ UseEffect ~~~~~~~~~~~~~~~~~~~~~~ //

    useEffect(() => {
        dataInit();
    }, [])

    // ~~~~~~~~~~~~~~~~~~~~~~ Init ~~~~~~~~~~~~~~~~~~~~~~ //

    const dataInit = async() => {
        await inviterInit();
        await userInitLine();
        await getMemberInit();
        handlerLoader('inactive');
    }

    // ~~~~~~~~~~~~~~~~~~~~~~ Line Login ~~~~~~~~~~~~~~~~~~~~~~ //

    const userInitLine = async() => {
        return new Promise(async resolve => {
            liff.init({ liffId: lineConfig.invite_friends }, async() => {
                if (liff.isLoggedIn()) {
                  let status = await runApp();
                  if(status===true) resolve();
                } else {
                liff.login();
                }
            }, err => console.error(err));
        })
    }
    const runApp = async() => {
        return new Promise(async resolve => {
            const idToken = liff.getIDToken();
            const accessToken = liff.getAccessToken();
            let lineProfile;
    
            liff.getProfile().then(profile => {
                lineProfile = {
                    id_token: idToken,
                    display_name: profile.displayName,
                    picture_url: profile.pictureUrl,
                    status_message: profile.statusMessage,
                    user_id: profile.userId,
                    access_token: accessToken
                }
                window.localStorage.setItem('line_profile', EncryptedOBJ(lineProfile));
                resolve(true);
            })
        })
    }

    // ~~~~~~~~~~~~~~~~~~~~~~ Handler ~~~~~~~~~~~~~~~~~~~~~~ //

    const handlerLoader = status => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    // ~~~~~~~~~~~~~~~~~~~~~~ Callback Function ~~~~~~~~~~~~~~~~~~~~~~ //

    const inviterInit = () => {
        return new Promise(async resolve => {
            if(!!inviterID)
            {
                // console.log('Have');
                // console.log('Inviter ID: ', inviterID);

                if(matchParams()) // params ที่ส่งมาต้องถูกต้อง | dsireu = userid
                {
                    // console.log('First Time');
                    // กรณีที่มี params(user id) ส่งมา คือจะเป็นครั้งแรกที่ user คลิกลิงก์ของ inviter 
                    localStorage.setItem('invitercode', EncryptedText(decodeURIComponent(inviterID)));
                    resolve();
                }else
                {
                    // console.log('Second Time');
                    let inviterCodeStorage = !!localStorage.getItem('invitercode') ? DecryptedText(localStorage.getItem('invitercode')) : null;
                    // console.log('Inviter Code Storage: ', inviterCodeStorage);

                    if(!!inviterCodeStorage)
                    {
                        resolve();
                    }else
                    {
                        // เข้ามารอบที่สองจาก callback (login line) ถ้าไม่มี inviter code ที่ save ไว้แสดงว่าผิดปกติ จะ alert error
                        showAlertError('ไม่พบข้อมูลผู้เชิญ ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่');
                    }
                }
            }
        })
    }

    const getMemberInit = () => {
        return new Promise(async resolve => {
            let lineInfo = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
    
            // console.log(lineInfo);

            if(!!lineInfo && lineInfo !== null)
            {
                NhealthAction.GetMember(lineInfo.user_id)
                .then(res => {
                    if(res.isSuccess === true)
                    {
                        let memberInfo = EncryptedOBJ(res.member);
                        localStorage.setItem('member_info', memberInfo);
                        window.location.href = `${Base_API.pathWeb}/n-health/mycard`
                        resolve();
                    }else
                    {
                        window.location.href = `${Base_API.pathWeb}/n-health/welcome-card-register` 
                    }
                    // console.log(res);
                })
            }else
            {
                window.location.reload();    
            }
        })
    }

    // ~~~~~~~~~~~~~~~~~~~~~~ Alert ~~~~~~~~~~~~~~~~~~~~~~ //

    const showAlertError = (msg) => {
        Swal.fire({
            title: "ผิดพลาด",
            text: msg,
            icon: 'error',
            confirmButtonText: 'ตกลง',
            allowOutsideClick: false,
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            },
        })
        .then(result => {
            if (result.isConfirmed) {
                window.location.reload();
            }
        })
    }

    // ~~~~~~~~~~~~~~~~~~~~~~ Utils ~~~~~~~~~~~~~~~~~~~~~~ //

    const matchParams = () => {
        let prefix = "luln"; // params ที่ใช้ส่ง | uesr id
        if(inviterID !== prefix) return true
        else return false
    }
    
    // ~~~~~~~~~~~~~~~~~~~~~~ Render ~~~~~~~~~~~~~~~~~~~~~~ //

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <></>
        )
    }
}

export default InviteeWelcome